module.exports = "/_next/static/media/feed-mobile.2d7f2964.png";